import React from 'react';
import styles from './License.module.css';

const LicenseUpdating = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        {/* Header */}
        <header className={styles.header}>
          <h1 className={styles.title}>📄 License Agreement</h1>
        </header>

        {/* Main Message */}
        <div className={styles.messageBox}>
          <div className={styles.messageIcon}>🔧</div>
          <h2 className={styles.messageTitle}>Updating Our License</h2>
          <p className={styles.messageText}>
            We are currently updating our license agreement documentation. 
            Please check back soon for the updated version.
          </p>
        </div>

      </div>
    </div>
  );
};

export default LicenseUpdating;